module.exports = __webpack_public_path__ + "img/user04.9b14574c.png";